import React, { Component } from "react";
import Form from 'react-bootstrap/Form';
import { Table } from 'react-bootstrap';
import { fetchPrograms, findProgramByDepartmentId } from './ProgramCache';
import { findDepartment, findDepartmentByName } from "./DepartmentCache";

export default function SetupSubmitTable(props) {
    let department
    let departmentId

    if (props.departmentId) {
        department = props.departments.find((d) => d.departmentId == props.departmentId)
        departmentId = props.departmentId
    } else if (props.departments) {
        department = props.departments.find((d) => d.departmentId == props.department.departmentId)
        departmentId = props.department.departmentId
    }
    
    return (
        <div>
            <Table>
                <thead>
                    <tr>
                        <th>Programs</th>
                        <th>Final mapping ready to be submitted</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        Object.keys(props.activePrograms).map((key, index) => (
                            <tr key={index}>
                                <td>{department.programList.find(p => p.programId == key).longName}</td>
                                <td>
                                    <Form.Select
                                        onChange={props.onSetupSubmitChanged}
                                        name={key}
                                        aria-label="Ask if this is official program submission."
                                        defaultValue={key in props.submittedPrograms ? props.submittedPrograms[key] : 'no'}
                                        disabled={!(key in props.activePrograms)}
                                        >
                                        <option value="no">No</option>
                                        <option value="yes">Yes</option>
                                    </Form.Select>
                                </td>
                            </tr>
                        ))
                    }
                </tbody>
            </Table>
        </div>
    )
}